import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  fr: {
    translation: {
      tagline: "Pour chaque entrepreneur congolais",
      nav: { home: "Accueil", market: "Marché", bourse: "Bourse", academia: "Academia", profile: "Profil" },
      sidebar: { menu: "Menu", account: "Compte" },
      role: {
        investor: "Investisseur",
        farmer: "Agriculteur",
        trader: "Commerçant",
        agent: "Agent terrain",
        admin: "Admin",
      },
      auth: {
        title: "Connexion",
        subtitle: "Accédez à votre coopérative",
        emailPlaceholder: "Email ou téléphone",
        passwordPlaceholder: "Mot de passe",
        forgot: "Mot de passe oublié ?",
        continue: "Continuer",
        or: "OU",
        google: "Continuer avec Google",
        roleLabel: "Je suis…",
        roleInvestor: "Investisseur",
        roleFarmer: "Agriculteur",
        roleMerchant: "Commerçant",
        roleAgent: "Agent terrain",
        noAccount: "Pas encore membre ?",
        signup: "Créer un compte",
        welcome: "Bienvenue ! 👋",
        fullNamePlaceholder: "Nom complet",
        signupTitle: "Créer un compte",
        signupSubtitle: "Rejoignez la coopérative Mombongo",
        forgotTitle: "Mot de passe oublié",
        forgotSubtitle: "Entrez votre email pour recevoir un lien de réinitialisation.",
        sendReset: "Envoyer le lien",
        resetSent: "Email envoyé ! Vérifiez votre boîte de réception.",
        alreadyAccount: "Déjà membre ?",
        backToLogin: "Retour à la connexion",
        createCta: "Créer mon compte",
        error: {
          userNotFound: "Aucun compte trouvé pour cet email.",
          wrongPassword: "Mot de passe incorrect.",
          emailInUse: "Cet email est déjà utilisé.",
          weakPassword: "Le mot de passe doit contenir au moins 6 caractères.",
          invalidEmail: "Adresse email invalide.",
          network: "Erreur réseau. Vérifiez votre connexion.",
          tooManyRequests: "Trop de tentatives. Réessayez dans quelques minutes.",
        },
      },
      common: {
        error: "Une erreur inattendue s'est produite.",
        unknown: "Utilisateur",
        close: "Fermer",
        switchLang: "Changer de langue",
      },
      loading: {
        didYouKnow: "Le saviez-vous ?",
      },
      error: {
        title: "Une erreur est survenue",
        description: "Rechargez la page ou revenez plus tard.",
        reload: "Recharger",
      },
      home: {
        greeting: "Bonjour, {{name}} 👋",
        dashTitle: "Tableau de bord",
        dashDesc: "Suivez vos investissements et découvrez de nouvelles opportunités",
        newInvest: "Nouvel investissement",
        portfolio: "Portefeuille total",
        totalPortfolio: "Portefeuille total",
        monthChange: "ce mois",
        avgRoi: "ROI moyen",
        invests: "Investissements",
        activeInvestsKpi: "Investissements actifs",
        gains: "Gains ce mois",
        monthGainsKpi: "Gains ce mois",
        nextReturn: "Prochain retour",
        nextReturnKpi: "Prochain retour",
        days: "jours",
        daysLeft: "j restants",
        harvest: "Récolte",
        actions: { invest: "Investir", bourse: "Bourse", academia: "Academia", finance: "Financement" },
        active: "Investissements actifs",
        myActiveInvests: "Mes investissements actifs",
        portfolioChart: "Évolution du portefeuille",
        recent: "Activité récente",
        recentActivity: "Activité récente",
        seeAll: "Voir tout",
        seeAllLink: "Tout voir",
        seeMore: "Voir plus",
        exploreMarket: "Explorer le marché",
        shortcuts: "Raccourcis",
        tipTitle: "Astuce du jour",
        tipBody: "Diversifiez entre maraîchage et export pour lisser vos rendements.",
        recommended: "Recommandé pour vous",
        recommendedDesc: "Sélectionné selon vos préférences et votre historique",
        newBadge: "NOUVEAU",
        commission: "comm.",
        farmerTitle: "Mes cultures",
        farmerDesc: "Suivez vos parcelles et rapports d'agent",
        surface: "Surface",
        progress: "Avancement",
        harvest2: "Récolte",
        noInvestments: "Aucun investissement actif",
        noInvestmentsDesc: "Explorez le marché pour découvrir des opportunités",
        browseMarket: "Explorer le marché",
        estimatedReturn: "Retour estimé",
        completed: "Terminé",
      },
      profile: {
        eyebrow: "Mon compte",
        description: "Gérez votre wallet, vos préférences et la sécurité de votre compte",
        walletLabel: "Wallet Mombongo",
        walletSection: "Wallet",
        available: "Disponible immédiatement",
        deposit: "Recharger",
        withdraw: "Retirer",
        langSection: "Langue",
        langCard: "Langue de l'application",
        accountSection: "Compte",
        security: "Compte & sécurité",
        notifications: "Notifications",
        notifUnread: "3 non lues",
        kyc: "Sécurité & KYC",
        kycStatus: "Vérification complète",
        documents: "Mes documents",
        documentsDesc: "2 contrats actifs",
        help: "Aide & contact",
        helpDesc: "WhatsApp, email",
        adminDesc: "Ouvrir le panneau admin dans un nouvel onglet",
        logout: "Déconnexion",
      },
      market: {
        title: "Marché",
        investTitle: "Opportunités d'investissement",
        search: "Rechercher un produit…",
        opportunities: "{{count}} opportunités disponibles",
        oppCount: "{{count}} cultures et services disponibles à travers la RDC",
        all: "Tous",
        agriculture: "Agriculture",
        logistics: "Logistique",
        export: "Export",
        bio: "Bio",
        coffee: "Café",
        fish: "Pêche",
        min: "Min",
        duration: "Durée",
        filtersTitle: "Filtres",
        categories: "Catégories",
        entryTicket: "Ticket d'entrée",
        region: "Région",
        sortRoi: "Trier : ROI ↓",
        sortMin: "Investissement min. ↑",
        sortDuration: "Durée ↑",
        minRoi: "ROI minimum",
        maxDuration: "Durée maximale",
        filterReset: "Réinitialiser",
        filterApply: "Appliquer",
        filterAny: "Tous",
      },
      bourse: {
        live: "Bourse en direct",
        title: "Marché agricole congolais",
        desc: "Cotations en temps réel et opportunités de commercialisation",
        subtitle: "Marché en temps réel",
        myPositions: "Mes positions",
        subscribe: "Souscrire",
        openOpportunities: "Opportunités ouvertes",
        volumeDay: "Volume du jour",
        opportunities: "Opportunités",
        avgCommission: "Commission moy.",
        activeSubscribers: "Souscripteurs actifs",
        volumeDayShort: "Volume jour",
        commShort: "Comm. moy.",
        ticket: "Ticket",
        comm: "Comm.",
        places: "places",
        opportunityCol: "Opportunité",
        typeCol: "Type",
        routeCol: "Trajet / Lieu",
        volumeCol: "Volume",
        ticketCol: "Ticket",
        commissionCol: "Commission",
        subscriptionCol: "Souscription",
        updatedAgo: "Mise à jour il y a 12s",
        newOpps: "+3 nouvelles",
        newSubs: "+12",
        empty: "Aucune opportunité ouverte",
        ticker: "Prix du marché en direct",
        departure: "Départ",
        capacity: "Capacité",
        filled: "rempli",
        invest: { label: "Investir", title: "Investir dans ce convoi", walletCdf: "Solde FC", estReturn: "Retour estimé", success: "Investissement confirmé !" },
      },
      academia: {
        eyebrow: "Academia Mombongo",
        title: "Apprendre à entreprendre",
        desc: "Cours pratiques, certifications et ressources pour développer votre activité agricole",
        levelBronze: "Niveau Bronze",
        xpToSilver: "Plus que {{xp}} XP pour atteindre le niveau Argent",
        completedCourses: "Cours terminés",
        inProgress: "En cours",
        certificates: "Certificats",
        continueLearn: "Continuer l'apprentissage",
        fullCatalog: "Catalogue complet",
        continueSection: "Continuer",
        catalogSection: "Catalogue",
        xpDisplay: "3 cours terminés · 240 XP",
        inProgressShort: "en cours",
        courseCompleted: "Terminé",
        courseStart: "Commencer",
        modules: "mod.",
        subtitle: "Apprendre à entreprendre",
        featured: "À la une",
        allCourses: "Tous les cours",
        filter: "Tous",
        enrolled: "inscrits",
        empty: "Aucun cours disponible",
        howItWorks: "Comment ça marche",
        enroll: "S'inscrire gratuitement",
        continue: "Continuer",
        progress: "Progression",
        locked: "Module verrouillé — inscrivez-vous",
        markComplete: "Marquer comme terminé",
        completed: "Terminé",
        prev: "Précédent",
        next: "Suivant",
        downloadPdf: "Télécharger le PDF",
        submitQuiz: "Soumettre",
        quizScore: "Score : {{score}}/{{total}}",
        congratulations: "Félicitations !",
        courseComplete: "Vous avez terminé : {{title}}",
        backToCourses: "Retour aux cours",
      },
      financement: {
        eyebrow: "Financement participatif",
        title: "Soutenez les agriculteurs congolais",
        desc: "$24,820 levés ce trimestre pour 18 agriculteurs · 96% de taux de remboursement",
        sponsor: "Devenir parrain",
        impactLabel: "Impact total · 2026 Q1",
        raisedFor: "levés pour {{count}} agriculteurs dans {{provinces}} provinces",
        hectaresLabel: "hectares financés",
        jobsLabel: "emplois soutenus",
        repayment: "remboursement",
        howItWorks: "Comment ça marche",
        collectTitle: "Agriculteurs en collecte",
        projectsActive: "{{count}} projets actifs",
        collected: "{{pct}}% collecté",
        support: "Soutenir",
        impactShort: "Impact total",
        raisedForShort: "levés pour 18 agriculteurs",
        haShort: "ha",
        jobsShort: "emplois",
        repaymentShort: "remb.",
        enCollecte: "En collecte",
        subtitle: "Soutenez nos agriculteurs",
      },
      pwa: {
        installTitle: "Installer l'application",
        installDesc: "Accédez à Mombongo directement depuis votre écran d'accueil",
        install: "Installer",
        updateAvailable: "Une mise à jour est disponible",
        update: "Mettre à jour",
      },
      financing: {
        title: "Financement agricole",
        filter: "Tous",
        harvest: "Récolte prévue",
        funded: "Financé",
        fund: "Financer",
        empty: "Aucun agriculteur disponible",
        progress: "Progrès du financement",
        walletBalance: "Solde portefeuille",
        remaining: "Restant",
        fundConfirm: "Vous allez financer {{name}} à hauteur de {{amount}}",
        confirm: "Confirmer",
        success: "Financement réussi !",
        minAmount: "Min. $50",
        tabFarmers: "Agriculteurs",
        tabCalendar: "Calendrier",
      },
      calendar: {
        title: "Calendrier cultural",
        crop: "Culture",
        planting: "Semis / Plantation",
        harvest: "Récolte",
        today: "Mois actuel",
      },
      onboarding: {
        skip: "Passer",
        back: "Retour",
        continue: "Continuer",
        saving: "Enregistrement…",
        error: "Une erreur est survenue. Réessayez.",
        goal: {
          eyebrow: "Bienvenue sur Mombongo",
          title: "Quel est votre principal objectif ?",
          subtitle: "Choisissez une option — vous pourrez tout faire ensuite.",
          sell: { title: "Vendre ma récolte", subtitle: "Trouver des acheteurs et publier mes annonces sur la Bourse" },
          credit: { title: "Obtenir un crédit agricole", subtitle: "Accéder à un financement pour développer mon exploitation" },
          monitor: { title: "Suivre ma ferme", subtitle: "Enregistrer mes cultures, récoltes et améliorer ma rentabilité" },
        },
        setup: {
          eyebrow: "Installation rapide",
          title: "Parlez-nous de votre exploitation",
          subtitle: "3 champs seulement — moins de 2 minutes.",
          subtitleExisting: "Sélectionnez une exploitation existante ou créez-en une nouvelle.",
          myExploitations: "Mes exploitations",
          createNew: "ou créer une nouvelle",
          noName: "Exploitation sans nom",
          hintTitle: "Votre exploitation",
          hintSub: "Vous pourrez compléter les détails plus tard",
          nameLabel: "Nom de l'exploitation",
          namePlaceholder: "Ex: Ferme Mukendi",
          cropLabel: "Culture principale",
          provinceLabel: "Province",
          submit: "Voir les prix du marché",
        },
        prices: {
          eyebrow: "Prix du marché",
          title: "Voici ce que vaut votre récolte aujourd'hui",
          today: "Prix constatés dans votre province aujourd'hui",
          noData: "Les prix pour cette région seront disponibles prochainement.",
          buyersSub: "cherchent du {{crop}} dans votre région en ce moment",
          next: "Voir mon profil Mombongo",
        },
        score: {
          eyebrow: "Votre profil",
          title: "Vous avez commencé votre parcours Mombongo",
          label: "Votre profil Mombongo",
          hint: "Complétez les étapes ci-dessous pour augmenter votre score et accéder à plus de services.",
          nextSteps: "Prochaines étapes",
          stepSurface: "Ajouter la surface de votre exploitation",
          stepKyc: "Vérifier mon identité (KYC)",
          stepListing: "Publier une première annonce",
          start: "Commencer",
        },
      },
      cta: {
        exploit: { title: "Créez votre première exploitation", subtitle: "Commencez le suivi de vos cultures et récoltes" },
        kyc: { title: "Complétez votre identité (KYC)", subtitle: "Vérifiez votre profil pour accéder à tous les services" },
        academia: { title: "Continuez votre formation pour débloquer la Bourse", subtitle: "{{xp}} XP acquis — encore {{remaining}} XP pour accéder à la Bourse" },
        firstListing: { title: "Publiez votre première annonce de vente", subtitle: "Mettez vos produits sur le marché Bourse" },
        financing_pending: { title: "Votre dossier de crédit est en cours", subtitle: "Votre demande est en cours d'examen par l'équipe" },
        financing_eligible: { title: "Vous êtes éligible à un crédit", subtitle: "Votre profil vous qualifie pour un financement agricole" },
        market: { title: "Vérifiez les prix du marché ce matin", subtitle: "Consultez les derniers prix agricoles dans votre région" },
      },
    },
  },
  en: {
    translation: {
      tagline: "For every Congolese entrepreneur",
      nav: { home: "Home", market: "Market", bourse: "Exchange", academia: "Academy", profile: "Profile" },
      sidebar: { menu: "Menu", account: "Account" },
      role: {
        investor: "Investor",
        farmer: "Farmer",
        trader: "Trader",
        agent: "Field agent",
        admin: "Admin",
      },
      auth: {
        title: "Sign In",
        subtitle: "Access your cooperative",
        emailPlaceholder: "Email or phone",
        passwordPlaceholder: "Password",
        forgot: "Forgot password?",
        continue: "Continue",
        or: "OR",
        google: "Continue with Google",
        roleLabel: "I am a…",
        roleInvestor: "Investor",
        roleFarmer: "Farmer",
        roleMerchant: "Trader",
        roleAgent: "Field agent",
        noAccount: "Not a member yet?",
        signup: "Create an account",
        welcome: "Welcome! 👋",
        fullNamePlaceholder: "Full name",
        signupTitle: "Create an account",
        signupSubtitle: "Join the Mombongo cooperative",
        forgotTitle: "Forgot password",
        forgotSubtitle: "Enter your email to receive a reset link.",
        sendReset: "Send reset link",
        resetSent: "Email sent! Check your inbox.",
        alreadyAccount: "Already a member?",
        backToLogin: "Back to sign in",
        createCta: "Create my account",
        error: {
          userNotFound: "No account found for this email.",
          wrongPassword: "Incorrect password.",
          emailInUse: "This email is already in use.",
          weakPassword: "Password must be at least 6 characters.",
          invalidEmail: "Invalid email address.",
          network: "Network error. Check your connection.",
          tooManyRequests: "Too many attempts. Try again in a few minutes.",
        },
      },
      common: {
        error: "An unexpected error occurred.",
        unknown: "User",
        close: "Close",
        switchLang: "Switch language",
      },
      loading: {
        didYouKnow: "Did you know?",
      },
      error: {
        title: "Something went wrong",
        description: "Reload the page or try again later.",
        reload: "Reload",
      },
      home: {
        greeting: "Hello, {{name}} 👋",
        dashTitle: "Dashboard",
        dashDesc: "Track your investments and discover new opportunities",
        newInvest: "New investment",
        portfolio: "Total Portfolio",
        totalPortfolio: "Total portfolio",
        monthChange: "this month",
        avgRoi: "avg ROI",
        invests: "Investments",
        activeInvestsKpi: "Active investments",
        gains: "Gains this month",
        monthGainsKpi: "Gains this month",
        nextReturn: "Next payout",
        nextReturnKpi: "Next return",
        days: "days",
        daysLeft: "d left",
        harvest: "Harvest",
        actions: { invest: "Invest", bourse: "Exchange", academia: "Academy", finance: "Financing" },
        active: "Active investments",
        myActiveInvests: "My active investments",
        portfolioChart: "Portfolio evolution",
        recent: "Recent activity",
        recentActivity: "Recent activity",
        seeAll: "See all",
        seeAllLink: "See all",
        seeMore: "See more",
        exploreMarket: "Explore market",
        shortcuts: "Shortcuts",
        tipTitle: "Tip of the day",
        tipBody: "Diversify between farming and export to smooth your returns.",
        recommended: "Recommended for you",
        recommendedDesc: "Selected based on your preferences and history",
        newBadge: "NEW",
        commission: "comm.",
        farmerTitle: "My crops",
        farmerDesc: "Track your plots and agent reports",
        surface: "Area",
        progress: "Progress",
        harvest2: "Harvest",
        noInvestments: "No active investments",
        noInvestmentsDesc: "Explore the market to find opportunities",
        browseMarket: "Explore market",
        estimatedReturn: "Estimated return",
        completed: "Completed",
      },
      profile: {
        eyebrow: "My account",
        description: "Manage your wallet, preferences and account security",
        walletLabel: "Mombongo Wallet",
        walletSection: "Wallet",
        available: "Available now",
        deposit: "Deposit",
        withdraw: "Withdraw",
        langSection: "Language",
        langCard: "App language",
        accountSection: "Account",
        security: "Account & security",
        notifications: "Notifications",
        notifUnread: "3 unread",
        kyc: "Security & KYC",
        kycStatus: "Fully verified",
        documents: "My documents",
        documentsDesc: "2 active contracts",
        help: "Help & support",
        helpDesc: "WhatsApp, email",
        adminDesc: "Open admin panel in a new tab",
        logout: "Log out",
      },
      market: {
        title: "Market",
        investTitle: "Investment opportunities",
        search: "Search a product…",
        opportunities: "{{count}} opportunities available",
        oppCount: "{{count}} crops and services available across DRC",
        all: "All",
        agriculture: "Agriculture",
        logistics: "Logistics",
        export: "Export",
        bio: "Organic",
        coffee: "Coffee",
        fish: "Fishing",
        min: "Min",
        duration: "Duration",
        filtersTitle: "Filters",
        categories: "Categories",
        entryTicket: "Entry ticket",
        region: "Region",
        sortRoi: "Sort: ROI ↓",
        sortMin: "Min. investment ↑",
        sortDuration: "Duration ↑",
        minRoi: "Minimum ROI",
        maxDuration: "Max duration",
        filterReset: "Reset",
        filterApply: "Apply",
        filterAny: "Any",
      },
      bourse: {
        live: "Live exchange",
        title: "Congolese agricultural market",
        desc: "Real-time quotes and market opportunities",
        subtitle: "Real-time market",
        myPositions: "My positions",
        subscribe: "Subscribe",
        openOpportunities: "Open opportunities",
        volumeDay: "Daily volume",
        opportunities: "Opportunities",
        avgCommission: "Avg. commission",
        activeSubscribers: "Active subscribers",
        volumeDayShort: "Daily vol.",
        commShort: "Avg. comm.",
        ticket: "Ticket",
        comm: "Comm.",
        places: "spots",
        opportunityCol: "Opportunity",
        typeCol: "Type",
        routeCol: "Route / Location",
        volumeCol: "Volume",
        ticketCol: "Ticket",
        commissionCol: "Commission",
        subscriptionCol: "Subscription",
        updatedAgo: "Updated 12s ago",
        newOpps: "+3 new",
        newSubs: "+12",
        empty: "No open opportunities",
        ticker: "Live market prices",
        departure: "Departure",
        capacity: "Capacity",
        filled: "filled",
        invest: { label: "Invest", title: "Invest in this route", walletCdf: "CDF balance", estReturn: "Estimated return", success: "Investment confirmed!" },
      },
      academia: {
        eyebrow: "Mombongo Academy",
        title: "Learn to grow",
        desc: "Practical courses, certifications and resources to grow your farming business",
        levelBronze: "Bronze level",
        xpToSilver: "Just {{xp}} XP to reach Silver level",
        completedCourses: "Completed",
        inProgress: "In progress",
        certificates: "Certificates",
        continueLearn: "Continue learning",
        fullCatalog: "Full catalog",
        continueSection: "Continue",
        catalogSection: "Catalog",
        xpDisplay: "3 completed · 240 XP",
        inProgressShort: "in progress",
        courseCompleted: "Completed",
        courseStart: "Start",
        modules: "mod.",
        subtitle: "Learn to grow",
        featured: "Featured",
        allCourses: "All courses",
        filter: "All",
        enrolled: "enrolled",
        empty: "No courses available",
        howItWorks: "How it works",
        enroll: "Enroll for free",
        continue: "Continue",
        progress: "Progress",
        locked: "Module locked — enroll first",
        markComplete: "Mark as complete",
        completed: "Completed",
        prev: "Previous",
        next: "Next",
        downloadPdf: "Download PDF",
        submitQuiz: "Submit",
        quizScore: "Score: {{score}}/{{total}}",
        congratulations: "Congratulations!",
        courseComplete: "You completed: {{title}}",
        backToCourses: "Back to courses",
      },
      financement: {
        eyebrow: "Crowdfunding",
        title: "Support Congolese farmers",
        desc: "$24,820 raised this quarter for 18 farmers · 96% repayment rate",
        sponsor: "Become a sponsor",
        impactLabel: "Total impact · 2026 Q1",
        raisedFor: "raised for {{count}} farmers across {{provinces}} provinces",
        hectaresLabel: "financed hectares",
        jobsLabel: "jobs supported",
        repayment: "repayment",
        howItWorks: "How it works",
        collectTitle: "Active campaigns",
        projectsActive: "{{count}} active projects",
        collected: "{{pct}}% raised",
        support: "Support",
        impactShort: "Total impact",
        raisedForShort: "raised for 18 farmers",
        haShort: "ha",
        jobsShort: "jobs",
        repaymentShort: "repay.",
        enCollecte: "Campaigns",
        subtitle: "Support our farmers",
      },
      pwa: {
        installTitle: "Install the app",
        installDesc: "Access Mombongo directly from your home screen",
        install: "Install",
        updateAvailable: "An update is available",
        update: "Update",
      },
      financing: {
        title: "Agricultural financing",
        filter: "All",
        harvest: "Expected harvest",
        funded: "Funded",
        fund: "Fund",
        empty: "No farmers available",
        progress: "Funding progress",
        walletBalance: "Wallet balance",
        remaining: "Remaining",
        fundConfirm: "You are funding {{name}} for {{amount}}",
        confirm: "Confirm",
        success: "Funding successful!",
        minAmount: "Min. $50",
        tabFarmers: "Farmers",
        tabCalendar: "Calendar",
      },
      calendar: {
        title: "Cultural calendar",
        crop: "Crop",
        planting: "Planting / Sowing",
        harvest: "Harvest",
        today: "Current month",
      },
      onboarding: {
        skip: "Skip",
        back: "Back",
        continue: "Continue",
        saving: "Saving…",
        error: "Something went wrong. Please try again.",
        goal: {
          eyebrow: "Welcome to Mombongo",
          title: "What is your main goal?",
          subtitle: "Choose one — you can do everything afterwards.",
          sell: { title: "Sell my harvest", subtitle: "Find buyers and post listings on the Exchange" },
          credit: { title: "Get an agricultural loan", subtitle: "Access financing to grow my farm" },
          monitor: { title: "Track my farm", subtitle: "Record crops, harvests and improve profitability" },
        },
        setup: {
          eyebrow: "Quick setup",
          title: "Tell us about your farm",
          subtitle: "3 fields only — less than 2 minutes.",
          subtitleExisting: "Select an existing farm or create a new one.",
          myExploitations: "My farms",
          createNew: "or create a new one",
          noName: "Unnamed farm",
          hintTitle: "Your farm",
          hintSub: "You can fill in the details later",
          nameLabel: "Farm name",
          namePlaceholder: "E.g. Mukendi Farm",
          cropLabel: "Primary crop",
          provinceLabel: "Province",
          submit: "See market prices",
        },
        prices: {
          eyebrow: "Market prices",
          title: "Here's what your harvest is worth today",
          today: "Prices recorded in your province today",
          noData: "Prices for this region will be available soon.",
          buyersSub: "are looking for {{crop}} in your area right now",
          next: "View my Mombongo profile",
        },
        score: {
          eyebrow: "Your profile",
          title: "You've started your Mombongo journey",
          label: "Your Mombongo profile",
          hint: "Complete the steps below to increase your score and unlock more services.",
          nextSteps: "Next steps",
          stepSurface: "Add your farm area",
          stepKyc: "Verify my identity (KYC)",
          stepListing: "Post a first listing",
          start: "Get started",
        },
      },
      cta: {
        exploit: { title: "Create your first farm", subtitle: "Start tracking your crops and harvests" },
        kyc: { title: "Complete your identity (KYC)", subtitle: "Verify your profile to access all services" },
        academia: { title: "Continue training to unlock the Exchange", subtitle: "{{xp}} XP earned — {{remaining}} more XP to access the Exchange" },
        firstListing: { title: "Post your first listing", subtitle: "Put your products on the Exchange market" },
        financing_pending: { title: "Your loan application is under review", subtitle: "Your request is being reviewed by the team" },
        financing_eligible: { title: "You are eligible for a loan", subtitle: "Your profile qualifies you for agricultural financing" },
        market: { title: "Check today's market prices", subtitle: "View the latest agricultural prices in your region" },
      },
    },
  },
  ln: {
    translation: {
      tagline: "Pona bato nyonso ya Kongo",
      nav: { home: "Ndako", market: "Libanda", bourse: "Bourse", academia: "Bino", profile: "Ya Ngai" },
      sidebar: { menu: "Biloko", account: "Compte" },
      role: {
        investor: "Mosambeli",
        farmer: "Mosali bilanga",
        trader: "Motekisi",
        agent: "Mosali na bilanga",
        admin: "Admin",
      },
      auth: {
        title: "Kokota",
        subtitle: "Kota na coopérative na yo",
        emailPlaceholder: "Email to telefoni",
        passwordPlaceholder: "Mot de passe",
        forgot: "Obosani mot de passe ?",
        continue: "Kokoba",
        or: "TO",
        google: "Kokoba na Google",
        roleLabel: "Ngai nazali…",
        roleInvestor: "Mosambeli",
        roleFarmer: "Mosali bilanga",
        roleMerchant: "Motekisi",
        roleAgent: "Mosali na bilanga",
        noAccount: "Ozali membre te ?",
        signup: "Kosala compte",
        welcome: "Boyei malamu! 👋",
        fullNamePlaceholder: "Kombo ya mobimba",
        signupTitle: "Kosala compte",
        signupSubtitle: "Kota na coopérative ya Mombongo",
        forgotTitle: "Obosani mot de passe",
        forgotSubtitle: "Tia email na yo mpo na kozwa link ya kobongola.",
        sendReset: "Tinda link",
        resetSent: "Email etindamaki ! Tala boîte na yo.",
        alreadyAccount: "Ozali membre kala ?",
        backToLogin: "Zonga na kokota",
        createCta: "Kosala compte na ngai",
        error: {
          userNotFound: "Compte ezwami te na email oyo.",
          wrongPassword: "Mot de passe ezali malamu te.",
          emailInUse: "Email oyo ezali kosalema.",
          weakPassword: "Mot de passe esengeli na caractère 6 to mingi.",
          invalidEmail: "Email ezali malamu te.",
          network: "Problème ya réseau. Tala connexion na yo.",
          tooManyRequests: "Mokokota mingi. Yaka lisusu nsima ya miniti.",
        },
      },
      common: {
        error: "Likambo ekómí. Suka lisusu.",
        unknown: "Moto",
        close: "Kanga",
        switchLang: "Bongola lokota",
      },
      loading: {
        didYouKnow: "Oyebaki ?",
      },
      error: {
        title: "Likambo ekómí",
        description: "Bongisa page to yaka lisusu.",
        reload: "Bongisa",
      },
      home: {
        greeting: "Mbote, {{name}} 👋",
        dashTitle: "Etando",
        dashDesc: "Tala ba investissements na yo mpe kuta ba opportunités ya sika",
        newInvest: "Kotia mbongo ya sika",
        portfolio: "Mosolo nyonso",
        totalPortfolio: "Mosolo nyonso",
        monthChange: "sanza oyo",
        avgRoi: "ROI moyenne",
        invests: "Ba investissements",
        activeInvestsKpi: "Ba investissements ya sika",
        gains: "Mbongo ya sanza",
        monthGainsKpi: "Mbongo ya sanza oyo",
        nextReturn: "Mbongo ya sima",
        nextReturnKpi: "Mbongo ya sima",
        days: "mikolo",
        daysLeft: "mikolo",
        harvest: "Kobuka",
        actions: { invest: "Kotia mbongo", bourse: "Bourse", academia: "Bino", finance: "Lisalisi" },
        active: "Ba investissements ya sika",
        myActiveInvests: "Ba investissements na ngai",
        portfolioChart: "Mosolo",
        recent: "Makambo ya sika",
        recentActivity: "Makambo ya sika",
        seeAll: "Tala nyonso",
        seeAllLink: "Tala nyonso",
        seeMore: "Tala lisusu",
        exploreMarket: "Tala libanda",
        shortcuts: "Batelemisi",
        tipTitle: "Toli ya lelo",
        tipBody: "Bongola bilanga na export mpo na kozwa mbongo malamu.",
        recommended: "Mpo na yo",
        recommendedDesc: "Kopona mpo na yo na ndinga ya suka",
        newBadge: "YA SIKA",
        commission: "comm.",
        farmerTitle: "Bilanga na ngai",
        farmerDesc: "Tala bilanga na rapports ya mosali",
        surface: "Esika",
        progress: "Elongeli",
        harvest2: "Kobuka",
        noInvestments: "Ezali te kotia mbongo",
        noInvestmentsDesc: "Tala libanda pona koluka likabo",
        browseMarket: "Tala libanda",
        estimatedReturn: "Mosolo ekozonga",
        completed: "Ekosili",
      },
      profile: {
        eyebrow: "Compte na ngai",
        description: "Bobateli mosolo, bilenge na bolamu ya compte na yo",
        walletLabel: "Mosolo Mombongo",
        walletSection: "Mosolo",
        available: "Ezo kozwa sikoyo",
        deposit: "Kotia",
        withdraw: "Kobima",
        langSection: "Lokota",
        langCard: "Lokota ya app",
        accountSection: "Compte",
        security: "Compte na bolamu",
        notifications: "Bandimi",
        notifUnread: "3 oyo elongwa te",
        kyc: "Bolamu & KYC",
        kycStatus: "Elongwamaki",
        documents: "Mikanda na ngai",
        documentsDesc: "Mianane 2",
        help: "Lisalisi",
        helpDesc: "WhatsApp, email",
        adminDesc: "Fungola admin na esika sika",
        logout: "Kobima",
      },
      market: {
        title: "Libanda",
        investTitle: "Ba opportunités ya kotia mbongo",
        search: "Luka eloko…",
        opportunities: "{{count}} ba opportunités",
        oppCount: "Ba bilanga {{count}} na ba services na molongo ya RDC",
        all: "Nyonso",
        agriculture: "Bilanga",
        logistics: "Mibembo",
        export: "Export",
        bio: "Bio",
        coffee: "Café",
        fish: "Mbisi",
        min: "Min",
        duration: "Mikolo",
        filtersTitle: "Bipengwa",
        categories: "Bintaka",
        entryTicket: "Ticket ya kobanda",
        region: "Etuka",
        sortRoi: "Bongola: ROI ↓",
        sortMin: "Min. kotia mbongo ↑",
        sortDuration: "Mikolo ↑",
        minRoi: "ROI ya kati",
        maxDuration: "Mikolo minene",
        filterReset: "Kobongola",
        filterApply: "Kosalela",
        filterAny: "Nyonso",
      },
      bourse: {
        live: "Bourse ya sikoyo",
        title: "Libanda ya bilanga ya Kongo",
        desc: "Prix ya sikoyo na ba opportunités ya sale",
        subtitle: "Libanda ya sikoyo",
        myPositions: "Bisika na ngai",
        subscribe: "Kokota",
        openOpportunities: "Ba opportunités ya sika",
        volumeDay: "Volume ya lelo",
        opportunities: "Ba opportunités",
        avgCommission: "Comm. moyenne",
        activeSubscribers: "Ba souscripteurs ya sika",
        volumeDayShort: "Volume lelo",
        commShort: "Comm. moy.",
        ticket: "Ticket",
        comm: "Comm.",
        places: "bisika",
        opportunityCol: "Opportunité",
        typeCol: "Ndenge",
        routeCol: "Nzela / Esika",
        volumeCol: "Volume",
        ticketCol: "Ticket",
        commissionCol: "Commission",
        subscriptionCol: "Kokota",
        updatedAgo: "Ebongwaki 12s eleki",
        newOpps: "+3 ya sika",
        newSubs: "+12",
        empty: "Likabo ezali te",
        ticker: "Ntalo ya sika",
        departure: "Kobima",
        capacity: "Litomba",
        filled: "etondaki",
        invest: { label: "Kotia mbongo", title: "Kotia mbongo na convoi oyo", walletCdf: "Mosolo FC", estReturn: "Mosolo ekozonga", success: "Kotia mbongo ekosalemi!" },
      },
      academia: {
        eyebrow: "Bino ya Mombongo",
        title: "Koyekola",
        desc: "Bisolo ya pratique na mapapelo mpo na kozala molongi",
        levelBronze: "Nivo Bronze",
        xpToSilver: "{{xp}} XP mpo na nivo Argent",
        completedCourses: "Bisolo ya suka",
        inProgress: "Na kati",
        certificates: "Mapapelo",
        continueLearn: "Kobanda koyekola",
        fullCatalog: "Bisolo nyonso",
        continueSection: "Kobanda lisusu",
        catalogSection: "Bisolo",
        xpDisplay: "Bisolo 3 suka · 240 XP",
        inProgressShort: "na kati",
        courseCompleted: "Suka",
        courseStart: "Kobanda",
        modules: "mod.",
        subtitle: "Koyekola",
        featured: "Ya suka",
        allCourses: "Bisolo nyonso",
        filter: "Nyonso",
        enrolled: "bayekoli",
        empty: "Bisolo ezalaka te",
        howItWorks: "Ndenge esalemi",
        enroll: "Kokota ofele",
        continue: "Kobanda lisusu",
        progress: "Progression",
        locked: "Esali ekangami — kokota liboso",
        markComplete: "Koloba ete esuki",
        completed: "Suka",
        prev: "Elongi",
        next: "Elandi",
        downloadPdf: "Kokitisa PDF",
        submitQuiz: "Kotinda",
        quizScore: "Score: {{score}}/{{total}}",
        congratulations: "Félicitations!",
        courseComplete: "Osuka bisolo: {{title}}",
        backToCourses: "Zonga na bisolo",
      },
      financement: {
        eyebrow: "Lisalisi ya bato",
        title: "Sungama basali bilanga",
        desc: "$24,820 botombami na trimestre oyo mpo na basali 18 · 96% ezongeli",
        sponsor: "Koba parrain",
        impactLabel: "Impact nyonso · 2026 Q1",
        raisedFor: "botombami mpo na basali {{count}} na bingumba {{provinces}}",
        hectaresLabel: "ba hectares",
        jobsLabel: "bisala",
        repayment: "ezongeli",
        howItWorks: "Ndenge oyo",
        collectTitle: "Ba collectes ya sika",
        projectsActive: "Misala {{count}}",
        collected: "{{pct}}% botombami",
        support: "Sungama",
        impactShort: "Impact nyonso",
        raisedForShort: "mpo na basali 18",
        haShort: "ha",
        jobsShort: "bisala",
        repaymentShort: "ezong.",
        enCollecte: "Ba collectes",
        subtitle: "Sungama basali bilanga",
      },
      pwa: {
        installTitle: "Kotia application",
        installDesc: "Kota na Mombongo na ekran ya ndako na yo",
        install: "Kotia",
        updateAvailable: "Pembo ya sika ezali",
        update: "Bongola",
      },
      financing: {
        title: "Lisalisi ya basali bilanga",
        filter: "Nyonso",
        harvest: "Mosika ya kobuka",
        funded: "Lisalisi esalemi",
        fund: "Sungama",
        empty: "Basali bilanga bayindi te",
        progress: "Progression ya lisalisi",
        walletBalance: "Mbongo ya portefeuille",
        remaining: "Ekosali",
        fundConfirm: "Okosungama {{name}} na {{amount}}",
        confirm: "Pesa accord",
        success: "Lisalisi esalemi !",
        minAmount: "Min. $50",
        tabFarmers: "Basali bilanga",
        tabCalendar: "Kalenda",
      },
      calendar: {
        title: "Kalenda ya bilanga",
        crop: "Bilanga",
        planting: "Koboma mboto",
        harvest: "Kobuka",
        today: "Sanza ya lelo",
      },
      onboarding: {
        skip: "Koleka",
        back: "Zonga",
        continue: "Kokoba",
        saving: "Kokoma…",
        error: "Likambo ekómí. Suka lisusu.",
        goal: {
          eyebrow: "Boyei malamu na Mombongo",
          title: "Makambo nini eleki ntina mpo na yo?",
          subtitle: "Pona likambo moko — okosala nyonso nsima.",
          sell: { title: "Koteka kobuka na ngai", subtitle: "Koluka bato ya kosomba mpe kotinda ba annonces na Bourse" },
          credit: { title: "Kozwa lisalisi ya bilanga", subtitle: "Kozwa mbongo mpo na kobongisa bilanga na ngai" },
          monitor: { title: "Kotala bilanga na ngai", subtitle: "Kokoma bilanga na kobuka mpe kobongisa mbongo na ngai" },
        },
        setup: {
          eyebrow: "Kotia na lombangu",
          title: "Yebisa biso mpo na bilanga na yo",
          subtitle: "Biloko 3 kaka — munene ya miniti 2.",
          subtitleExisting: "Pona bilanga oyo ezali to sala ya sika.",
          myExploitations: "Bilanga na ngai",
          createNew: "to sala ya sika",
          noName: "Bilanga kozinga kombo te",
          hintTitle: "Bilanga na yo",
          hintSub: "Okozala na ntango mpo na kobakisa biloko nsima",
          nameLabel: "Kombo ya bilanga",
          namePlaceholder: "Ndakisa: Bilanga ya Mukendi",
          cropLabel: "Bilanga ya liboso",
          provinceLabel: "Bingumba",
          submit: "Tala ntalo ya libanda",
        },
        prices: {
          eyebrow: "Ntalo ya libanda",
          title: "Oyo ntalo ya kobuka na yo lelo",
          today: "Ntalo ya bingumba na yo lelo",
          noData: "Ntalo ya esika oyo ekoya sika.",
          buyersSub: "baluki {{crop}} na esika na yo sikoyo",
          next: "Tala profil na ngai ya Mombongo",
        },
        score: {
          eyebrow: "Profil na yo",
          title: "Obandaki nzela ya Mombongo",
          label: "Profil na yo ya Mombongo",
          hint: "Suka ba étapes oyo mpo na kobakisa score na yo mpe kozwa ba services mingi.",
          nextSteps: "Ba étapes elandi",
          stepSurface: "Bakisa litomba ya bilanga na yo",
          stepKyc: "Kolakisa bozali ngai (KYC)",
          stepListing: "Kotinda annonce ya liboso",
          start: "Kobanda",
        },
      },
      cta: {
        exploit: { title: "Sala bilanga ya liboso na yo", subtitle: "Kobanda kotala bilanga na kobuka na yo" },
        kyc: { title: "Kokamata identité na yo (KYC)", subtitle: "Tia profil na yo malamu mpo na kozwa ba services nyonso" },
        academia: { title: "Kobanda lisusu koyekola mpo na Bourse", subtitle: "{{xp}} XP — lisusu {{remaining}} XP mpo na Bourse" },
        firstListing: { title: "Tinda annonce ya liboso ya koteka", subtitle: "Tia biloko na yo na Bourse" },
        financing_pending: { title: "Dossier na yo ya crédit etalelemi", subtitle: "Bademande na yo etalelemi na bato na biso" },
        financing_eligible: { title: "Okoki kozwa crédit", subtitle: "Profil na yo elingisi yo mpo na lisalisi ya bilanga" },
        market: { title: "Tala ntalo ya libanda lelo tongo", subtitle: "Tala ntalo ya sika ya bilanga na esika na yo" },
      },
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: (localStorage.getItem("mb_lang") as string) || "fr",
  fallbackLng: "fr",
  interpolation: { escapeValue: false },
});

export default i18n;
